<template>
  <div>
      <section class="section p-0 bg d-flex align-items-center justify-content-center">
          <div class="container text-center"><h1 class="text-white" v-if="page != 0">{{page[0].NAME}}</h1><Breadcrumbs :title="page[0].NAME"/></div>
      </section>
        <section class="section">
            <div class="container"  v-if="page != 0">
                <card class="row px-5 py-3" v-html="page[0].DETAIL_TEXT" shadow></card>
            </div>
        </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: []
    };
  },
  mounted() {
    this.loadInfo()
  },
  methods: {
    async loadInfo() {
      let path = this.$route.path.replace(/(\\|\/)/g, "")
      let params = new Map();
      params.set("code", path);
      params.set("entity", "pages");

      this.page = await this.$root.loadContent(params);
      if(this.page !== undefined){
        this.$root.title = this.page[0]["SEO"]["ELEMENT_META_TITLE"];
        this.$root.description =this.page[0]["SEO"]["ELEMENT_META_DESCRIPTION"];
      } else {
        this.page = 0
      }
    },
  },
};
</script>
